import { render, staticRenderFns } from "./TopicClusterLinkAnalysis2.vue?vue&type=template&id=61cb5ad2&scoped=true"
import script from "./TopicClusterLinkAnalysis2.vue?vue&type=script&lang=js"
export * from "./TopicClusterLinkAnalysis2.vue?vue&type=script&lang=js"
import style0 from "./TopicClusterLinkAnalysis2.vue?vue&type=style&index=0&id=61cb5ad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cb5ad2",
  null
  
)

export default component.exports